export default __webpack_public_path__ + "static/media/Meals4MeIcon.52999091.png";